import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import Chip from 'Chip';
// assets
// import LogoImg from '../../assets/logo1x.pgitng';

const Logo = ({ content }) => {
    const { logo } = content;

return (
        <div className={styles.wrap}>
                <a href="" target="_blank">
                <Chip 
                    key="base"
                    id="260152" 
                    name="base"
                    type="struct" 
                    title="Logo" 
                    groupName="头部" 
                    content={logo}
                >
                    <img src={logo} />
                </Chip>
                </a>
        </div>
    );
};

Logo.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Logo);
